import { render, staticRenderFns } from "./dynamic-document-number-brick-template.vue?vue&type=template&id=79242da7&"
import script from "./dynamic-document-number-brick-template.vue?vue&type=script&lang=ts&"
export * from "./dynamic-document-number-brick-template.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports